import {businessIndustryChoices} from "@/form/helpers/field-choices.js";

let steps = [
    // STEP 1 — Postal Code
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__postal_code__",
        fields: [
            {
                name: "postal_code",
                placeholder: 'A9A9A9',
                type: "text",
                value: null,
                validationRules: "required|postal",
                fieldOuterClass: "col-md-8 offset-md-2",
                hideIfHasValue: true,
                attrs: { maxlength: 7 },
            },
        ],
    },
    // STEP 2 — Company Information
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__company_information__',
        fields: [
            {
                label: '__company_name__',
                name: 'company_name',
                type: 'text',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 100
                },
            },
            {
                label: '__industry__',
                name: 'business_type',
                placeholder: '',
                type: 'select',
                value: null,
                // inChoices: a prepopped code the list no longer offers (e.g. LAW_FIRM) must be
                // replaced by the applicant, not silently submitted behind a blank select.
                validationRules: 'required|inChoices',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: businessIndustryChoices(),
                hideIfHasValue: false,
            },
            {
                label: '__average_monthly_sales__',
                name: 'monthly_gross_sales',
                placeholder: '50000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 7
                },
            },
            {
                label: '__average_monthly_sales_cards__',
                name: 'monthly_card_sales',
                placeholder: '50000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 7
                },
            },
            {
                label: '__business_start_date__',
                name: 'business_start_date',
                placeholder: null,
                type: 'date',
                value: null,
                validationRules: 'required|date',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
            },
            {
                label: '__payment_processor__',
                name: 'payment_processor',
                placeholder: '',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"value":"CHASE_PAYMENTECH", "text":"__opt_business_payment_processor_chase_paymentech__"},
                    {"value":"DEBITECH", "text":"__opt_business_payment_processor_debitech__"},
                    {"value":"DESJARDINS", "text":"__opt_business_payment_processor_desjardins__"},
                    {"value":"ELAVON", "text":"__opt_business_payment_processor_elavon__"},
                    {"value":"EVERLINK", "text":"__opt_business_payment_processor_everlink__"},
                    {"value":"FIRST_DATA", "text":"__opt_business_payment_processor_first_data__"},
                    {"value":"GLOBAL_PAYMENTS", "text":"__opt_business_payment_processor_global_payments__"},
                    {"value":"MERCURY_PAYMENTS", "text":"__opt_business_payment_processor_mercury_payments__"},
                    {"value":"MONERIS", "text":"__opt_business_payment_processor_moneris__"},
                    {"value":"MONEX", "text":"__opt_business_payment_processor_monex__"},
                    {"value":"PAYFIRMA", "text":"__opt_business_payment_processor_payfirma__"},
                    {"value":"PIVOTAL_PAYMENTS", "text":"__opt_business_payment_processor_pivotal_payments__"},
                    {"value":"POS_WEST", "text":"__opt_business_payment_processor_pos_west__"},
                    {"value":"SQUARE", "text":"__opt_business_payment_processor_square__"},
                    {"value":"STRIPE", "text":"__opt_business_payment_processor_stripe__"},
                    {"value":"TD_MERCHANT_SERVICES", "text":"__opt_business_payment_processor_td_merchant_services__"},
                    {"value":"OTHER", "text":"__opt_business_payment_processor_other__"},
                    {"value":"NONE", "text":"__opt_business_payment_processor_none__"},
                ],
                hideIfHasValue: false,
            },
        ],
    },
    // STEP 3 — Contact Info
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: "__address_city__",
                name: "city",
                type: "text",
                value: null,
                validationRules: "required",
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: true,
                attrs: { maxlength: 50 },
            },
            {
                label: "__province__",
                name: "state",
                type: "select",
                value: null,
                validationRules: "required",
                fieldOuterClass: "col-md-8 offset-md-2",
                choices: [
                    {"value":"AB", "text":"ALBERTA"},
                    {"value":"BC", "text":"BRITISH COLUMBIA"},
                    {"value":"MB", "text":"MANITOBA"},
                    {"value":"NB", "text":"NEW BRUNSWICK"},
                    {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
                    {"value":"NS", "text":"NOVA SCOTIA"},
                    {"value":"ON", "text":"ONTARIO"},
                    {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
                    {"value":"QC", "text":"QUEBEC"},
                    {"value":"SK", "text":"SASKATCHEWAN"},
                    {"value":"NT", "text":"NORTHWEST TERRITORIES"},
                    {"value":"NU", "text":"NUNAVUT"},
                    {"value":"YT", "text":"YUKON"},
                ],
                hideIfHasValue: true,
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
                textBottom: '__phone_number_sms_results__'
            },
        ],
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
];

export default steps;
